import { Const } from "const"
import { MemberRole, WpActionTypes, WpConver, WpPostInfo, WpTitle, WorkPlaceTagFilter, WpStatus, WpPostType, WpEmpFilterType, TaskStatus, WorkPlaceTagUnreadSignalR, WpFilterTaskDueMode } from "./wpTypes"
import { TABS, WpModes, WpSortMode } from "../../constants"
import { Utils } from "helpers/utils"
import { WpPostInfoMem } from "helpers/wpPostInfoMem"

export const apiOk = (type: WpActionTypes, data: any) => {
  return {
    type: WpActionTypes.API_OK,
    payload: { type: type, errMsg: "", data: data }
  }
}

export const apiErr = (type: WpActionTypes, errMsg: string) => {
  return {
    type: WpActionTypes.API_ERR
    , payload: { type: type, errMsg: errMsg, data: null }
  }
}

export const setActivePostId2 = (
  wpMode: WpModes,
  activePostId: string | null,
  activePostTitle: string | null, activePostAbbr: string | null = null, activePostAbbrFore: string | null = null, activePostAbbrBack: string | null = null,
  setFrom: string | null = null,
  knownTitleRow: WpTitle | null = null, // prefill from the list row already in memory, so the header doesn't blank out while the network fetch is in flight
) => {
  const newTitle = wpMode == WpModes.Workplace ? Const.TEXT_NEW_WP_POST : wpMode == WpModes.Task ? Const.TEXT_NEW_WP_TASK : "N/A";
  const memPostInfo = activePostId ? WpPostInfoMem.get(wpMode, activePostId) : null;
  const activePostInfo: WpPostInfo = {
    wpMode: wpMode,
    postId: activePostId,
    title: activePostTitle ?? "",
    icon: knownTitleRow?.icon ?? "",
    abbrName: activePostAbbr ?? "",
    abbrFore: activePostAbbrFore ?? "",
    abbrBack: activePostAbbrBack ?? "",
    tags: memPostInfo?.tags ?? [],
    flag: knownTitleRow?.flag ?? false,
    snooze: knownTitleRow?.snooze ?? false,
    isYourPost: activePostId == "" && activePostTitle == newTitle/*"ตั้งโพสใหม่"*/,
    canChangeStatus: false,
    canDeletePost: false,
    youIsMember: (activePostId == "" && activePostTitle == newTitle/*"ตั้งโพสใหม่"*/) || (activePostId != "" && activePostTitle == "reload"),
    status: knownTitleRow?.status ?? WpStatus.Open,
    statusById: null,
    statusDate: null,
    statusRemark: null,
    statusByName: null,
    taskStatus: knownTitleRow?.taskStatus ?? TaskStatus.ToDo,
    planFinishedDate: knownTitleRow?.planFinishedDate ?? null,
    actFinishedDate: knownTitleRow?.actFinishedDate ?? null,
    isTaskOverdue: knownTitleRow?.isTaskOverdue ?? null,
    isSubTask: knownTitleRow?.isSubTask ?? null,
  };
  // console.log('setActivePostId:', { setFrom, activePostId });
  return {
    type: WpActionTypes.SET_ACTIVE_POSTID2,
    payload: {
      activePostInfo, setFrom, wpMode
    }
  }
}

export const loadMorePostConver = (wpMode: WpModes, postId: string, beforePostDateTime: Date, beforePostId: string) => {
  return {
    type: WpActionTypes.LOAD_MORE_POST_CONVER,
    payload: {
      wpMode, postId, beforePostDateTime, beforePostId
    }
  }
}

export const setCreateSubTask = (createSubTaskFromTaskId: string | null) => {
  return {
    type: WpActionTypes.SET_CREATE_SUB_TASK,
    payload: {
      createSubTaskFromTaskId: createSubTaskFromTaskId
    }
  }
}

export const loadPostTitleActionV2 = (wpMode: WpModes, keyword: string, tagSet: string[], memberRole: MemberRole, tagIds: number[] | null, filterUnRead: boolean
  , filterNotClose: boolean, empFilterType: WpEmpFilterType/*includeFilterEmpRelated: boolean*/, tagCatMatchedAll?: string[] | null, callFrom?: string
  , filterTaskStatus?: TaskStatus[] | null
  , filterFromDash?: boolean | null, taskResponder?: string | null | undefined, taskAssigner?: any | null, taskRequester?: any | null
  , taskRange1?: Date | null, taskRange2?: Date | null, includeTaskRecurance?: boolean | null
  , filterTaskDueMode?: WpFilterTaskDueMode | null
  , sortMode?: WpSortMode | null
) => {
  return {
    type: wpMode == WpModes.Workplace ? WpActionTypes.LOAD_POST_TITLE_WP : WpActionTypes.LOAD_POST_TITLE_TK,
    payload: {
      wpMode, keyword, tagSet, memberRole, tagIds, filterUnRead, filterNotClose, empFilterType/*includeFilterEmpRelated*/, tagCatMatchedAll, callFrom, taskStatus: filterTaskStatus
      , filterFromDash, taskResponder, taskAssigner, taskRequester
      , taskRange1, taskRange2, includeTaskRecurance
      , filterTaskDueMode
      , sortMode
    }
  }
}

// used for a dashboard-filtered task list, where the row set is fixed and only the display order needs to change
export const sortTitlesTkLocal = (sortMode: WpSortMode) => {
  return {
    type: WpActionTypes.SORT_TITLES_TK_LOCAL,
    payload: { sortMode }
  }
}

export const loadPostConver = (postId: string) => {
  return {
    type: WpActionTypes.LOAD_POST_CONVER,
    payload: { postId }
  }
}

export const loadPostInfo = (wpMode: WpModes, postId: string) => {
  return {
    type: WpActionTypes.LOAD_POST_INFO2,
    payload: { wpMode, postId }
  }
}

export const appendPostConver = (postData: WpConver[]) => {
  return {
    type: WpActionTypes.APPEND_POST_CONVER,
    payload: { postData }
  }
}

export const setDraftPost = (wpMode: WpModes, postId: string, draft: boolean) => {
  return {
    type: WpActionTypes.SET_DRAFT_POST,
    payload: { wpMode, postId, draft }
  }
}

export const setActiveMemberrole = (wpMode: WpModes, memberRole: MemberRole) => {
  return {
    type: WpActionTypes.SET_ACTIVE_MEMBERROLE,
    payload: { wpMode, memberRole }
  }
}

export const setPostInfoOnSignalR = (postInfo: WpPostInfo, lastChatText: string, lastChatTime: Date, lastChatImg: string, unreadCount: number, memberRoles: MemberRole[]) => {
  return {
    type: WpActionTypes.SET_POST_INFO_ON_SIGNALR,
    payload: { postInfo, lastChatText, lastChatTime, lastChatImg, unreadCount, memberRoles }
  }
}

export const setPostInfoOnly = (postInfo: WpPostInfo) => {
  return {
    type: WpActionTypes.SET_POST_INFO_ONLY,
    payload: { postInfo }
  }
}

export const getRoleUnreadCount = (sendNotification: boolean) => {
  return {
    type: WpActionTypes.GET_ROLE_UNREAD_COUNT,
    payload: { sendNotification }
  }
}

export const updatePostUnreadCount = (wpMode: WpModes, postId: string, memberId: number, unreadCount: number) => {
  return {
    type: WpActionTypes.UPDATE_POST_UNREAD_COUNT,
    payload: { wpMode, postId, memberId, unreadCount }
  }
}

export const setFilterSelected = (wpMode: WpModes, tagSelected: WorkPlaceTagFilter[] | undefined, filterNotClose: boolean | undefined) => {
  return {
    type: WpActionTypes.SET_FILTER_SELECTED,
    payload: { wpMode, tagSelected, filterNotClose }
  }
}

export const setShareFilterWpTask = (shareFilterWpTask: boolean) => {
  return {
    type: WpActionTypes.SET_SHARE_FILTER_WP_TASK,
    payload: { shareFilterWpTask }
  }
}

export const setKeywordAction = (wpMode: WpModes, keyword: string, searchNow: boolean = false) => {
  return {
    type: WpActionTypes.SET_KEYWORD,
    payload: { wpMode, keyword, searchNow }
  }
}

// export const setFilterTaskDueModeAction = (mode: WpFilterTaskDueMode) => {
//   return {
//     type: WpActionTypes.SET_FILTER_TASK_DUEMODE,
//     payload: { mode }
//   }
// }

export const setTaskStatusFilter = (taskStatus: TaskStatus | null) => {
  return {
    type: WpActionTypes.SET_TASK_STATUS_FILTER,
    payload: { taskStatus }
  }
}

export const clearAllFilterAction = (wpMode: WpModes) => {
  return {
    type: WpActionTypes.CLEAR_ALL_FILTER,
    payload: { wpMode }
  }
}

export const setTagUnreadOnSignalR = (tagUnread: WorkPlaceTagUnreadSignalR[]) => {
  return {
    type: WpActionTypes.TAG_UNREAD_ON_SIGNALR,
    payload: { tagUnread }
  }
}

export const setFlag = (wpMode: WpModes, postId: string, flag: boolean) => {
  return {
    type: WpActionTypes.SET_FLAG,
    payload: { wpMode, postId, flag }
  }
}

export const setPostIcon = (wpMode: WpModes, postId: string, icon: string) => {
  return {
    type: WpActionTypes.SET_POST_ICON,
    payload: { wpMode, postId, icon }
  }
}

export const removePostTitleFromList = (postId: string) => {
  return {
    type: WpActionTypes.REMOVE_POST_TITLE_FROM_LIST,
    payload: { postId }
  }
}

export const setSnooze = (wpMode: WpModes, postId: string, snooze: boolean) => {
  return {
    type: WpActionTypes.SET_SNOOZE,
    payload: { wpMode, postId, snooze }
  }
}

export const setUnread = (wpMode: WpModes, postId: string, unread: number) => {
  return {
    type: WpActionTypes.SET_UNREAD,
    payload: { wpMode, postId, unread }
  }
}

export const markAsRead = (wpMode: WpModes, postIds: string) => {
  return {
    type: WpActionTypes.MARK_AS_READ,
    payload: { wpMode, postIds }
  }
}


export const togglePostEmoji = (postIdParent: string, postId: string, emojiName: string, emojiIcon: string, isAdd: boolean, memberName: string) => {
  return {
    type: WpActionTypes.TOGGLE_POST_EMOJI,
    payload: { postIdParent, postId, emojiName, emojiIcon, isAdd, memberName }
  }
}

export const markPostUnSend = (wpMode: WpModes, postIdParent: string, postId: string, isDelPost: boolean) => {
  return {
    type: WpActionTypes.MARK_POST_UNSEND,
    payload: { wpMode, postIdParent, postId, isDelPost }
  }
}

export const changePostStatus = (wpMode: WpModes, postIdParent: string, status: WpStatus) => {
  return {
    type: WpActionTypes.CHANGE_POST_STATUS,
    payload: { wpMode, postIdParent, status }
  }
}

export const setIsEmbChatOnly = (isEmbChatOnly: boolean) => {
  return {
    type: WpActionTypes.SET_IS_EMB_CHAT_ONLY,
    payload: { isEmbChatOnly }
  }
}

export const loadDllEmployee = () => {
  return {
    type: WpActionTypes.LOAD_DLL_EMPLOYEE,
    payload: {}
  }
}

export const setPostIdForInstanceAction = (postId: string | null) => {
  return {
    type: WpActionTypes.WP_SET_POSTID_FOR_INSTANCE,
    payload: { postId }
  }
}

export const loadTaskDashActV2 = (divMode: "DIV_RSP" | "DIV_ASG" | "DIV_REQ", statusRange1: Date | null, statusRange2: Date | null, filterTagId: number | null, includeTaskRecurance?: boolean | null) => {
  if (!statusRange1) statusRange1 = Utils.GetFirstDateOfWeek(null);
  if (!statusRange2) statusRange2 = Utils.GetLastDateOfWeek(null);
  return {
    type: WpActionTypes.WP_LOAD_TASK_DASH,
    payload: { divMode, statusRange1, statusRange2, filterTagId, includeTaskRecurance }
  }
}

export const loadTaskDashboardByDivAct = (divMode: "DIV_RSP" | "DIV_ASG" | "DIV_REQ", statusRange1: Date | null, statusRange2: Date | null, filterTagId: number | null, includeTaskRecurance?: boolean | null) => {
  if (!statusRange1) statusRange1 = Utils.GetFirstDateOfWeek(null);
  if (!statusRange2) statusRange2 = Utils.GetLastDateOfWeek(null);
  return {
    type: WpActionTypes.WP_LOAD_TASK_DASHBOARD_BY_DIV,
    payload: { divMode, statusRange1, statusRange2, filterTagId, includeTaskRecurance }
  }
}


export const loadTaskDashRecurance = () => {
  return {
    type: WpActionTypes.WP_LOAD_TASK_DASH_RECURANCE,
    payload: {}
  }
}


export const loadTaskDashTagsActV2 = (includeTaskRecurance?: boolean | null) => {
  return {
    type: WpActionTypes.WP_LOAD_TASK_DASH_TAGS,
    payload: { includeTaskRecurance }
  }
}

export const loadTaskDashStatusRangeActV2 = (statusRange1: Date, statusRange2: Date, filterTagId: number | null, includeTaskRecurance?: boolean | null) => {
  return {
    type: WpActionTypes.WP_LOAD_TASK_DASH_STATUSRANGE,
    payload: { statusRange1, statusRange2, filterTagId, includeTaskRecurance }
  }
}

export const loadSubTask = (parentTaskId: string) => {
  return {
    type: WpActionTypes.WP_LOAD_SUB_TASK,
    payload: { parentTaskId }
  }
}

export const setTaskDashFilterTagId = (filterTagId: number | null) => {
  return {
    type: WpActionTypes.WP_SET_TASK_DASH_FILTER_TAGID,
    payload: { filterTagId }
  }
}

export const tagMasterCatLoad = () => {
  return {
    type: WpActionTypes.WP_TAG_MASTER_CAT_LOAD,
    payload: {}
  }
}
